import { createSelector } from '@reduxjs/toolkit';

import type {
  ContactFormServerErrors,
  ContactPartnerState,
} from 'src/components/molecules/ContactPartnerModal/types';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';

export const selectContactFormServerErrors = createSelector(
  [(state: ReduxApplicationState) => state.contactPartnerModal.error],
  (serverErrors: ContactPartnerState['error']): ContactFormServerErrors => ({
    email: serverErrors?.email?.join(', '),
    name: serverErrors?.name?.join(', '),
    message: serverErrors?.message?.join(', '),
    rateLimitMessage: serverErrors?.rateLimitMessage,
  }),
);
